import React, {Component} from "react";
import {FormText, Label, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledAlert} from "reactstrap";
import Datetime from "react-datetime";
import moment from "moment/moment";
import {deepCopyObject, showAxiosError} from "../helper/helper";
import Alert from "react-s-alert";
import {request} from "../helper/APIUtils";
import * as content from "../constants/exportcontent";
import {smsToExcel} from "../constants/exportcontent";

class SmsReportToExcel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customizerModal:true,
            isAll: true,
            value: null,
            tag: null,
            disableTagging:false,
            smsDates: {
                baslangicTarihi: "",
                bitisTarihi: "",
            },

        };

        this.closeSmsReportModal = this.closeSmsReportModal.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.exportSmsToExcel = this.exportSmsToExcel.bind(this);
        this.checkDateValidity = this.checkDateValidity.bind(this);
        this.exportCustomXls = this.exportCustomXls.bind(this);
        this.arrangeDataSet = this.arrangeDataSet.bind(this);
        this.create_UUID = this.create_UUID.bind(this);
    }

    closeSmsReportModal() {
        this.setState({customizerModal: false});
        this.props.closeClickSms();
    }

    onChangeDate(momentObj, type, fieldName) {

        let value;
        let {smsDates} = this.state;
        if (!(typeof momentObj === "string")) {

            value = momentObj.format("YYYY-MM-DD");

        } else {
            value = moment(momentObj,"YYYY-MM-DD");
        }
        smsDates[fieldName] = value;
        this.setState({smsDates})
    }

    checkDateValidity(current, field) {
        if (field === 'bitisTarihi') {
            let startDate = moment(this.state.smsDates.baslangicTarihi);
            return current.isAfter(startDate);
        }
    }

    async exportSmsToExcel(){
        let modifiedContent = [];

        modifiedContent = content.smsToExcel;
        modifiedContent.map(mc => mc.selected = true);
        this.setState({
            content: modifiedContent,
            data: modifiedContent
        });
        let  data = modifiedContent;
        let isAll = deepCopyObject(this.state.isAll);
        let startDate = moment(this.state.smsDates.baslangicTarihi,"DD-MM-YYYY");
        let finishDate = moment(this.state.smsDates.bitisTarihi,"DD-MM-YYYY")
        if (!isAll && (!startDate || !finishDate)) {
            Alert.error('Geçerli bir tarih aralığı giriniz', {
                html: true,
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            })
        } else {
            await this.setState({customHeaders: data, noDocumentError: false},
                () => this.exportCustomXls());
            this.closeSmsReportModal();
            await this.sleep(2000);
        }
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async exportCustomXls() {
        this.setState({buttonStyle: 'fas fa-spinner fa-spin'});
        let self = this;
        let data = self.arrangeDataSet('custom');
        let params = {
            url: self.props.url, //TODO: self
            method: "post",
            data: data,
        };
        self.setState({manual: self.manual === true ? false : self.manual});
        await request(params).then(function (response) {
            self.setState({buttonStyle: null, noDocumentError: false});
            self.props.triggerDownloadRequestTooltip();
        }).catch(function (error) {
            self.setState({buttonStyle: null, noDocumentError: true});
            showAxiosError(error);
        });
    }

    arrangeDataSet() {
        let dataSet = {};

        dataSet.headers = this.state.customHeaders;
        dataSet.sheetName = this.props.sheetName;

        let queryPayload = {};

        queryPayload.startDate = (deepCopyObject(this.state.smsDates.baslangicTarihi) === null || undefined) ? "" : deepCopyObject(this.state.smsDates.baslangicTarihi);
        queryPayload.finishDate = (deepCopyObject(this.state.smsDates.bitisTarihi) === null || undefined) ? "" : deepCopyObject(this.state.smsDates.bitisTarihi);
        queryPayload.completeFetch = false;
        queryPayload.docType = 'smsExcel';

        let filterMap = {};
        filterMap.vknTckn = this.state.vknTckn;
        queryPayload.filterMap = filterMap;

        dataSet.xlsQueryPayload = queryPayload;
        dataSet.uuid = this.create_UUID();
        dataSet.year = this.props.year;

        return dataSet;
    }

    create_UUID() {
        let dt = new Date().getTime();
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }

    render()
    {
        return (
            <div>
                <Modal isOpen={this.state.customizerModal}>
                    <ModalHeader toggle={this.closeSmsReportModal}>Sms Raporu </ModalHeader>
                    <ModalBody>
                        <div>
                            <Label for="baslangicTarihi">Başlangıç Tarihi</Label>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      input={true}
                                      closeOnSelect={true}
                                      value={moment(this.state.smsDates.baslangicTarihi, "YYYY-MM-DD", true).isValid() ? moment(this.state.smsDates.baslangicTarihi).format("DD-MM-YYYY") : this.state.smsDates.baslangicTarihi}
                                      disabled={this.state.isAll}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat={false}
                                      onChange={(e) => this.onChangeDate(e, "date", "baslangicTarihi")}/>
                            <Label for="bitisTarihi">Bitiş Tarihi</Label>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      input={true}
                                      closeOnSelect={true}
                                      value={moment(this.state.smsDates.bitisTarihi, "YYYY-MM-DD", true).isValid() ? moment(this.state.smsDates.bitisTarihi).format("DD-MM-YYYY") : this.state.smsDates.bitisTarihi}
                                      disabled={this.state.isAll}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat={false}
                                      isValidDate={(current) => this.checkDateValidity(current, "bitisTarihi")}
                                      onChange={(e) => this.onChangeDate(e, "date", "bitisTarihi")}/>
                            <br/>
                            <Label for="baslangicTarihi">**Tarih aralığı girilmediğinde tümünü getirecektir.</Label>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-sm-4">
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '8px 41px 8px 17px'}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.closeSmsReportModal}>
                                İptal
                            </button>
                        </div>
                        <div className="col-sm-4"></div>
                        <div className="col-sm-4">
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding: '8px 41px 8px 17px'}}
                                    rel="tooltip" className="TekBtn kaydet"
                                    onClick={this.exportSmsToExcel}>
                                Onayla
                            </button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    };
}

export default SmsReportToExcel;